import { Link } from 'react-router-dom';
import { EntityImage } from '@urbanx/agx-ui-components';
import { AgentDetails, Team, TeamMember } from '@urbanx/agx.agencies.client';
import { AgxAvatarGroup, AgxColumn, AgxTypography } from '@urbanx/agx.ui-components2';

import './TeamDisplay.scss';
import { useMemo } from 'react';

interface TeamDisplayProps {
  team: Team;
  to: string;
  agents: AgentDetails[];
}

const sortMembersByPhoto = (a: TeamMember, b: TeamMember, agents: AgentDetails[]) => {
  const agentA = agents.find((agent) => agent.id === a.agentId);
  const agentB = agents.find((agent) => agent.id === b.agentId);

  const hasPhotoA = !!agentA?.photo?.publicPath;
  const hasPhotoB = !!agentB?.photo?.publicPath;

  return hasPhotoA === hasPhotoB ? 0 : hasPhotoA ? -1 : 1;
};

const TeamDisplay = ({ team, to, agents }: TeamDisplayProps) => {
  const sortedTeamMemberAvatars = useMemo(() => {
    return (
      (team.members ?? [])
        .sort((a, b) => sortMembersByPhoto(a, b, agents))
        .map((m) => {
          const agent = agents.find((agent) => agent.id === m.agentId);
          return agent?.photo?.publicPath ?? agent?.firstName ?? '';
        }) ?? []
    );
  }, [team, agents]);

  return (
    <Link to={to} className="teamDisplay">
      <AgxColumn gap={'spacing-xl'} padding={'spacing-3xl'}>
        <div className="teamAvatar">
          {team.photoUri ? (
            <img src={team.photoUri ?? ''} className="teamAvatarImg"></img>
          ) : (
            <EntityImage
              addRingToImage={false}
              name={team.name}
              size={72}
              backgroundColour={'rgba(0,0,0,0)'}
            />
          )}
        </div>
        <AgxTypography id={'teamName'} type={'body'} size={'large'}>
          {team.name}
        </AgxTypography>
        <AgxAvatarGroup size="medium" avatars={sortedTeamMemberAvatars} />
      </AgxColumn>
    </Link>
  );
};

export default TeamDisplay;
